import { createAction } from '@ngrx/store';

export const showSpinnerAction = createAction('[Spinner Actions] Show Spinner');
export const hideSpinnerAction = createAction('[Spinner Actions] Hide Spinner');

